import { render, staticRenderFns } from "./QueueView.vue?vue&type=template&id=7b4065e6&scoped=true"
import script from "./QueueView.vue?vue&type=script&lang=js"
export * from "./QueueView.vue?vue&type=script&lang=js"
import style0 from "./QueueView.vue?vue&type=style&index=0&id=7b4065e6&prod&lang=scss&scoped=true"
import style1 from "./QueueView.vue?vue&type=style&index=1&id=7b4065e6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b4065e6",
  null
  
)

export default component.exports